import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const TestIcon = (): JSX.Element => (
  <SVGUniqueID>
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <rect width={32} height={32} rx={16} fill="#FFCB4A" />
        <path d="M7.61 32.578h15.533V10.542H10.861l-3.252 3.251z" fill="#fff" />
        <path
          d="M23.143 28.853v3.725H7.61V13.793l2.002-2.001c.307 8.175 5.942 14.984 13.532 17.061"
          fill="#EFEFEF"
        />
        <path d="M10.86 10.542v3.251H7.61z" fill="#B45656" />
        <path
          d="M10.861 11.535v2.258H8.676a18 18 0 0 0 2.185-2.258"
          fill="#7F1D1D"
        />
        <path
          d="M22.42 32.759H7.608a.18.18 0 0 1-.18-.18V13.792c0-.048.019-.094.052-.128l3.252-3.25a.18.18 0 0 1 .128-.054h12.282c.1 0 .18.081.18.181V30.5a.18.18 0 0 1-.36 0V10.723H10.934L7.79 13.868v18.53h14.63a.18.18 0 0 1 0 .36"
          fill="#09092D"
        />
        <path
          d="M18.306 8h-3.158c-.655 0-1.185.53-1.185 1.185h4.343z"
          fill="#7F1D1D"
        />
        <path
          d="M19.095 9.185v1.185c0 .654-.53 1.184-1.184 1.184h-3.555c-.654 0-1.184-.53-1.184-1.184V9.185z"
          fill="#B45656"
        />
        <path
          d="M18.036 11.867H14.48c-.762 0-1.381-.62-1.381-1.381V9.3a.197.197 0 0 1 .395 0v1.185c0 .544.442.987.986.987h3.555a.99.99 0 0 0 .986-.987V9.3a.197.197 0 0 1 .395 0v1.185c0 .762-.62 1.381-1.381 1.381"
          fill="#09092D"
        />
        <path
          d="M18.084 10.764H14.53a.197.197 0 0 1 0-.395h3.554a.198.198 0 0 1 0 .395m.394-1.185a.2.2 0 0 1-.197-.197v-.987h-3.949v.987a.198.198 0 0 1-.395 0V8.197c0-.109.089-.197.198-.197h4.343c.11 0 .198.088.198.197v1.185a.2.2 0 0 1-.198.197m-7.503 3.949h10.66a.198.198 0 0 0 0-.395h-10.66a.197.197 0 0 0 0 .395m0 2.764h10.66a.198.198 0 0 0 0-.395h-10.66a.197.197 0 0 0 0 .395m0 2.905h10.66a.198.198 0 0 0 0-.395h-10.66a.198.198 0 0 0 0 .395m0 3h10.66a.198.198 0 0 0 0-.395h-10.66a.198.198 0 0 0 0 .395"
          fill="#09092D"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width={32} height={32} rx={16} fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { TestIcon };
